import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, combineLatest } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  getAppConfigKeys,
  setAppConfigKeys,
  saveAppConfigKeys,
  deleteAppConfigKeys,
  setEnvironments
} from '../actions/appconfigkeys.actions';
@Injectable()
export class AppConfigKeysEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getAppConfigKeys$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getAppConfigKeys),
        map((action) => {
          const query = action.searchFields;
          const apiConstants = { ...action.apiConstants.environment };
          apiConstants.url = action.apiConstants.environment.url + action.appId;
          return combineLatest([
            this.baseService[action.apiConstants?.environment.method](apiConstants, JSON.stringify(query)),
            this.baseService[action.apiConstants?.configKeys.method](action.apiConstants.configKeys)
          ]).subscribe((results: any) => {
            this.store.dispatch(
              setEnvironments({
                environmentsTable: results[0]
              })
            );
            this.store.dispatch(
              setAppConfigKeys({
                appconfigkeysTable: results[1]
              })
            );
          });
        })
      ),
    { dispatch: false }
  );

  saveAppConfigKeys$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveAppConfigKeys),
        map((action) =>
          this.baseService[action.saveapiConstants?.method](
            action.saveapiConstants,
            action.appconfigkeysData
          ).subscribe((result: any) => {
            /* no-op */
          })
        )
      ),
    { dispatch: false }
  );

  deleteAppConfigKeys$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteAppConfigKeys),
        map((action) =>
          this.baseService[action.deleteApiConstants?.method](
            action.deleteApiConstants,
            action.appconfigkeysId
          ).subscribe((result: any) => {
            // no-op
          })
        )
      ),
    { dispatch: false }
  );
}
